<template>
  <li class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle"
      href="javascript:void(0);"
      id="navbar-dropdown"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      {{ authenticated_user.name }}
    </a>
    <ul class="dropdown-menu dropdown-menu-end">
      <li v-if="authenticated_user.user_profile.name === 'Admin'">
        <a class="dropdown-item" href="javascript:void(0);" @click.prevent="selectControlPanel()">
          {{ selected_control_panel == 'admin' ? 'Operacional' : 'Administrativo' }}
        </a>
      </li>
      <li v-if="authenticated_user.user_profile.name === 'Admin'">
        <hr class="dropdown-divider">
      </li>
      <li>
        <a class="dropdown-item" href="javascript:void(0);" @click.prevent="logout">Sair</a>
      </li>
    </ul>
  </li>
</template>

<script>
  import { computed } from 'vue'
  import { useRouter } from 'vue-router'
  import { useStore } from 'vuex'

  export default {
    name: 'App',
    setup() {
      const router = useRouter()
      const store = useStore()

      const authenticated_user = computed(
        () => store.getters.authenticated_user,
      )
      const selected_control_panel = computed(
        () => store.getters.selected_control_panel,
      )

      const logout = () => {
        store
          .dispatch('logout')
          .then(() => {
            router.replace({ name: 'login' })
          })
          .catch(() => {})
      }

      const selectControlPanel = () => {
        if (selected_control_panel.value == 'operational') {
          store
            .dispatch('selectControlPanel', 'admin')
            .then(() => {
              router.replace({ name: 'companies' })
            })
            .catch(() => {})
        } else {
          store
            .dispatch('selectControlPanel', 'operational')
            .then(() => {
              router.replace({ name: 'index' })
            })
            .catch(() => {})
        }
      }

      return {
        authenticated_user,
        logout,
        selected_control_panel,
        selectControlPanel,
      }
    },
  }
</script>
